module.exports = __webpack_public_path__ + "static/media/check.a105f277.svg";